// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  DeclaredEnumMember,
  DeclaredEnumMemberT,
  verifyDeclaredEnumMember,
} from "./declared-enum-member";
import { FieldKind } from "./field-kind";

/**
 * One argument of a declared command, in IDL argument order. A struct
 * argument appears as its fields, each with a dotted name.
 */
export class DeclaredArg implements flatbuffers.IUnpackableObject<DeclaredArgT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): DeclaredArg {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsDeclaredArg(bb: flatbuffers.ByteBuffer, obj?: DeclaredArg): DeclaredArg {
    return (obj || new DeclaredArg()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsDeclaredArg(
    bb: flatbuffers.ByteBuffer,
    obj?: DeclaredArg,
  ): DeclaredArg {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new DeclaredArg()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  typeName(): string | null;
  typeName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  typeName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  width(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  kind(): FieldKind {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : FieldKind.Unsigned;
  }

  enumMembers(index: number, obj?: DeclaredEnumMember): DeclaredEnumMember | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new DeclaredEnumMember()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  enumMembersLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startDeclaredArg(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nameOffset, 0);
  }

  static addTypeName(builder: flatbuffers.Builder, typeNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, typeNameOffset, 0);
  }

  static addWidth(builder: flatbuffers.Builder, width: number) {
    builder.addFieldInt8(2, width, 0);
  }

  static addKind(builder: flatbuffers.Builder, kind: FieldKind) {
    builder.addFieldInt8(3, kind, FieldKind.Unsigned);
  }

  static addEnumMembers(builder: flatbuffers.Builder, enumMembersOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, enumMembersOffset, 0);
  }

  static createEnumMembersVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startEnumMembersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endDeclaredArg(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createDeclaredArg(
    builder: flatbuffers.Builder,
    nameOffset: flatbuffers.Offset,
    typeNameOffset: flatbuffers.Offset,
    width: number,
    kind: FieldKind,
    enumMembersOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    DeclaredArg.startDeclaredArg(builder);
    DeclaredArg.addName(builder, nameOffset);
    DeclaredArg.addTypeName(builder, typeNameOffset);
    DeclaredArg.addWidth(builder, width);
    DeclaredArg.addKind(builder, kind);
    DeclaredArg.addEnumMembers(builder, enumMembersOffset);
    return DeclaredArg.endDeclaredArg(builder);
  }

  unpack(): DeclaredArgT {
    return new DeclaredArgT(
      this.name(),
      this.typeName(),
      this.width(),
      this.kind(),
      this.bb!.createObjList<DeclaredEnumMember, DeclaredEnumMemberT>(
        this.enumMembers.bind(this),
        this.enumMembersLength(),
      ),
    );
  }

  unpackTo(_o: DeclaredArgT): void {
    _o.name = this.name();
    _o.typeName = this.typeName();
    _o.width = this.width();
    _o.kind = this.kind();
    _o.enumMembers = this.bb!.createObjList<DeclaredEnumMember, DeclaredEnumMemberT>(
      this.enumMembers.bind(this),
      this.enumMembersLength(),
    );
  }

  unpackFields(...fields: string[]): DeclaredArgT {
    const t = new DeclaredArgT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("type_name")) {
      t.typeName = this.typeName();
    }
    if (fieldSet.has("width")) {
      t.width = this.width();
    }
    if (fieldSet.has("kind")) {
      t.kind = this.kind();
    }
    if (fieldSet.has("enum_members")) {
      t.enumMembers = this.bb!.createObjList<DeclaredEnumMember, DeclaredEnumMemberT>(
        this.enumMembers.bind(this),
        this.enumMembersLength(),
      );
    }
    return t;
  }
}

export class DeclaredArgT implements flatbuffers.IGeneratedObject {
  constructor(
    public name: string | Uint8Array | null = null,
    public typeName: string | Uint8Array | null = null,
    public width: number = 0,
    public kind: FieldKind = FieldKind.Unsigned,
    public enumMembers: DeclaredEnumMemberT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const typeName = this.typeName !== null ? builder.createString(this.typeName!) : 0;
    const enumMembers = DeclaredArg.createEnumMembersVector(
      builder,
      builder.createObjectOffsetList(this.enumMembers),
    );

    return DeclaredArg.createDeclaredArg(
      builder,
      name,
      typeName,
      this.width,
      this.kind,
      enumMembers,
    );
  }

  clone(): DeclaredArgT {
    const obj = new DeclaredArgT();
    obj.name = this.name;
    obj.typeName = this.typeName;
    obj.width = this.width;
    obj.kind = this.kind;
    obj.enumMembers = this.enumMembers.map((e) => e.clone());
    return obj;
  }

  equals(other: DeclaredArgT): boolean {
    if (this.name !== other.name) return false;
    if (this.typeName !== other.typeName) return false;
    if (this.width !== other.width) return false;
    if (this.kind !== other.kind) return false;
    if (this.enumMembers.length !== other.enumMembers.length) return false;
    for (let i = 0; i < this.enumMembers.length; i++) {
      const a = this.enumMembers[i];
      const b = other.enumMembers[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyDeclaredArg(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyDeclaredEnumMember);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
